import { deviceFloorLevel, floorCode } from "config/constants";
import React from "react";
import { useSelector } from "react-redux";
import { getCachedItem } from "utils/localStorage";

export default function useGetFloorLvl() {
  // Default floor level will be the physical floor where the device get configured
  const defaultFloor = getCachedItem(deviceFloorLevel);

  const [floorLevl, setFloorLevl] = React.useState(defaultFloor);
  const [didMount, setDidMount] = React.useState(false);
  const instruction = useSelector((state) => state.filter.filterByFloor);
  const filterFloorFromHome = useSelector(
    (state) => state.filter.filterFloorFromHome
  );

  React.useEffect(() => {
    setDidMount(true);
  }, ["didMount"]);

  React.useEffect(() => {
    if (filterFloorFromHome || didMount) {
      switch (instruction.code) {
        case floorCode[0]:
          setFloorLevl(0);
          break;
        case floorCode[1]:
          setFloorLevl(1);
          break;
        case floorCode[2]:
          setFloorLevl(2);
          break;
        case floorCode[3]:
          setFloorLevl(3);
          break;
        case floorCode[4]:
          setFloorLevl(4);
          break;
      }
    }
  }, [instruction.code, filterFloorFromHome]);

  return floorLevl;
}
